import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Avatar } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { EntitiesViewContext, LoansViewContext, ProfileViewContext } from '../../../Private';
import { useGetUserLoggin } from 'services/user/querys';
import './MobileBottomNav.scss';

const avatarColors = ["purple", "yellow", "blue"];
const colorSelected = avatarColors[Math.floor(Math.random() * avatarColors.length)];

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const { data: user, fetching: loadingUser } = useGetUserLoggin();

  const { visible: visibleEntities, setHandlerVisible: setVisibleEntities }: any = useContext(EntitiesViewContext);
  const { visible: visibleLoans, setHandlerVisible: setVisibleLoans }: any = useContext(LoansViewContext);
  const { visible: visibleProfile, setHandlerVisible: setVisibleProfile }: any = useContext(ProfileViewContext);

  // Check if we're on the main dashboard (no panels open)
  const isOnDashboard = !visibleLoans && !visibleEntities && !visibleProfile;

  const activeOption = (visible: 'loans' | 'entities' | 'profile' | 'dashboard') => {
    if (visible === 'dashboard') {
      setVisibleLoans(false);
      setVisibleEntities(false);
      setVisibleProfile(false);
    } else {
      setVisibleLoans(visible === 'loans');
      setVisibleEntities(visible === 'entities');
      setVisibleProfile(visible === 'profile');
    }
  }

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('fromOAuth');
    window.dispatchEvent(new Event("storage"));
    navigate("/login");
    navigate(0);
  }

  return (
    <nav className="mobile-bottom-nav">
      <Link 
        className={`mobile-bottom-nav__item ${isOnDashboard ? 'mobile-bottom-nav__item--active' : ''}`}
        to="./"
        onClick={() => activeOption('dashboard')}
      >
        <span className="mobile-bottom-nav__icon mobile-bottom-nav__icon--home" />
        <span className="mobile-bottom-nav__label">Loan Tasks</span>
      </Link>
      <Link 
        className={`mobile-bottom-nav__item ${visibleLoans ? 'mobile-bottom-nav__item--active' : ''}`}
        to="./"
        onClick={() => activeOption('loans')}
      >
        <span className="mobile-bottom-nav__icon mobile-bottom-nav__icon--loans" />
        <span className="mobile-bottom-nav__label">Loans</span>
      </Link>
      <Link 
        className={`mobile-bottom-nav__item ${visibleEntities ? 'mobile-bottom-nav__item--active' : ''}`}
        to="./"
        onClick={() => activeOption('entities')}
      >
        <span className="mobile-bottom-nav__icon mobile-bottom-nav__icon--entities" />
        <span className="mobile-bottom-nav__label">Entities</span>
      </Link>
      <button 
        className="mobile-bottom-nav__item"
        onClick={logout}
      >
        <span className="mobile-bottom-nav__icon mobile-bottom-nav__icon--logout" />
        <span className="mobile-bottom-nav__label">Log out</span>
      </button>
      <Link 
        className={`mobile-bottom-nav__item ${visibleProfile ? 'mobile-bottom-nav__item--active' : ''}`}
        to="./"
        onClick={() => activeOption('profile')}
      >
        <Avatar 
          src={!loadingUser && user?.avatar?.url} 
          size={28} 
          className={`mobile-bottom-nav__avatar mobile-bottom-nav__avatar--${colorSelected}`}
        >
          {!user?.avatar && (user?.name?.charAt(0) + (user?.lastName?.charAt(0) || ''))}
          {(loadingUser) && <LoadingOutlined />}
        </Avatar>
      </Link>
    </nav>
  );
};

export default MobileBottomNav;
